module.exports = __webpack_public_path__ + "static/ce-logo-7773fcab6818b9927f02e2ec435c0111.svg";